import(/* webpackMode: "eager" */ "/vercel/path0/public/preloader.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/shop/shop-page/components/Shop.tsx");
